import HttpRequest from '@/libs/axios'
import config from '@/config'
const url = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro
const axios = new HttpRequest(url)
export default axios
export const baseUrl=url
